import React from 'react'
import { Row, Select } from 'antd'
import { useTranslation } from 'next-i18next'
import { useAppSelector } from 'src/app/hooks'
import { currencyListSelector } from 'src/features'
import { CustomCol, FormLabels, CustomSelect } from 'src/components'

const SaleOfferCurrency: React.FC = () => {
  const { t } = useTranslation()
  const currencyList = useAppSelector(currencyListSelector)

  return <Row>
    <CustomCol>
      <FormLabels
        title={t('Projects.Currency')}
        subtitle={t('SalesOffer.CurrencyLabel')}
      />
    </CustomCol>
    <CustomCol>
      <CustomSelect
        name='currency'
        placeholder={t('Projects.currencyPlaceHolder')}
        required
      >
        {currencyList.map(c => <Select.Option key={c.id} value={c.id}>{`${c.code} ${c.symbol}`}</Select.Option>)}
      </CustomSelect>
    </CustomCol>
  </Row>
}

export default SaleOfferCurrency
